define(['santa-components', 'lodash', 'prop-types', 'componentsCore', 'coreUtilsLib'], function (santaComponents, _, PropTypes, componentsCore, coreUtilsLib) {
    'use strict';

    const SimpleDrag = coreUtilsLib.SimpleDrag;


    function getAudioState(muted, hasAudio, disableAudio) {
        if (!hasAudio || disableAudio) {
            return '';
        }
        return muted ? 'volumeOff' : 'volumeOn';
    }

    /**
     * @class components.MediaControlVolume
     * @extends {core.skinBasedComp}
     */
    return {
        displayName: 'MediaControlVolume',
        mixins: [componentsCore.mixins.skinBasedComp, componentsCore.mixins.createChildComponentMixin],

        propTypes: {
            style: PropTypes.object,
            playerId: PropTypes.string.isRequired,
            hasAudio: PropTypes.bool.isRequired,
            disableAudio: PropTypes.bool.isRequired,
            volume: PropTypes.number,
            muted: PropTypes.bool,
            svgPropsMapForMediaControls: PropTypes.object,
            handleBehavior: santaComponents.santaTypesDefinitions.Behaviors.handleBehavior.isRequired
        },

        getInitialState() {
            this.isDragging = false;
            return {};
        },

        clickActionMute() {
            if (!this.props.hasAudio) {
                return;
            }
            const command = this.props.muted ? 'unMute' : 'mute';
            this.props.handleBehavior({
                type: 'comp',
                targetId: this.props.playerId,
                name: command
            });
        },

        setVolumeOnSeek(state) {
            this.props.handleBehavior({
                type: 'comp',
                targetId: this.props.playerId,
                name: 'setVolume',
                params: {
                    volume: state.endX / state.maxX
                }
            });
        }, /**
         * @param {MouseEvent} event
         * @param {{endX: number, minX: number, maxX: number, screenX: number, endY: number, minY: number, maxY: number, screenY: number, dragging: boolean}} state
         */
        onDragStart(event, state) {
            this.isDragging = true;
            this.refs.volumeBarActive.style.width = `${state.endX / state.maxX * 100}%`;
            this.setVolumeOnSeek(state);
        },
        /**
         * @param {MouseEvent} event
         * @param {{endX: number, minX: number, maxX: number, screenX: number, endY: number, minY: number, maxY: number, screenY: number, dragging: boolean}} state
         */
        onDrag(event, state) {
            this.refs.volumeBarActive.style.width = `${state.endX / state.maxX * 100}%`;
            this.setVolumeOnSeek(state);
        },
        /**
         * @param {MouseEvent} event
         * @param {{endX: number, minX: number, maxX: number, screenX: number, endY: number, minY: number, maxY: number, screenY: number, dragging: boolean}} state
         */
        onDragEnd(event, state) {
            this.isDragging = false;
            this.setVolumeOnSeek(state);
        },
        /**
         * @param event
         */
        volumeSeekStart(event) {
            const drag = SimpleDrag({ //eslint-disable-line new-cap
                onDragStart: this.onDragStart,
                onDragEnd: this.onDragEnd,
                onDrag: this.onDrag,
                minX: 0,
                maxX: event.target.offsetWidth,
                offsetX: event.clientX - event.currentTarget.getBoundingClientRect().left
            });

            drag.start(event);
        },

        /**
         * Get a vectorImage by current symbol name
         * @param {string} iconSymbolName
         * @returns {ReactCompositeComponent}
         */
        getIconComponent(iconSymbolName) {
            const iconProps = _.get(this.props.svgPropsMapForMediaControls, iconSymbolName);
            const props = _.assign({
                id: `${this.props.id}icon`,
                key: iconSymbolName,
                ref: 'icon',
                preserveViewBox: true
            }, iconProps);

            return this.createChildComponent(null, 'wysiwyg.viewer.components.VectorImage', 'icon', props);
        },

        getSkinProperties() {
            const audioState = getAudioState(this.props.muted, this.props.hasAudio, this.props.disableAudio);
            const skinProps = {
                '': {
                    style: this.props.style
                },
                volume: {
                    className: this.classSet({
                        'muted': this.props.muted,
                        'disabled': !this.props.hasAudio || this.props.disableAudio
                    })
                },
                mute: {
                    onClick: this.clickActionMute
                },
                icon: audioState ? this.getIconComponent(audioState) : null,
                volumeBarActive: {
                    style: {
                        width: `${this.props.volume * 100}%`
                    }
                }
            };

            if (!this.props.muted) {
                _.assign(skinProps, {
                    volumeBarDragArea: {
                        onMouseDown: this.volumeSeekStart
                    }
                });
            }

            return skinProps;
        }
    };
});
